/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { RootBridge } from "./RootBridge";

export class RootBridgeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<RootBridge> {
    return super.deploy(overrides || {}) as Promise<RootBridge>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): RootBridge {
    return super.attach(address) as RootBridge;
  }
  connect(signer: Signer): RootBridgeFactory {
    return super.connect(signer) as RootBridgeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RootBridge {
    return new Contract(address, _abi, signerOrProvider) as RootBridge;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "bridge",
        type: "address",
      },
    ],
    name: "BridgeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "mediator",
        type: "address",
      },
    ],
    name: "MultiTokenMediatorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Relayed",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ambBridge",
    outputs: [
      {
        internalType: "contract IAMB",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_amount",
        type: "tuple",
      },
    ],
    name: "erc20Transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAMB",
        name: "_ambBridge",
        type: "address",
      },
      {
        internalType: "contract IMultiTokenMediator",
        name: "_multiTokenMediator",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "multiTokenMediator",
    outputs: [
      {
        internalType: "contract IMultiTokenMediator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeed",
    outputs: [
      {
        internalType: "contract IPriceFeed",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAMB",
        name: "_ambBridge",
        type: "address",
      },
    ],
    name: "setAMBBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IMultiTokenMediator",
        name: "_multiTokenMediator",
        type: "address",
      },
    ],
    name: "setMultiTokenMediator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
    ],
    name: "setPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_priceFeedAddrOnL2",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_price",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_roundId",
        type: "uint256",
      },
    ],
    name: "updatePriceFeed",
    outputs: [
      {
        internalType: "bytes32",
        name: "messageId",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
